import { Component, inject, signal } from '@angular/core';
import { NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { DokaButton, DokaModal, DokaModalController, DokaTextField } from '@doka/angular-core';
import { I18NextEagerPipe, I18NextService } from 'angular-i18next';
import { firstValueFrom } from 'rxjs';
import { CreateCurrencyModel, CurrenciesClient } from 'src/api/services/generated/api-clients';
import { ToastService } from 'src/app/shared/services/toast.service';

@Component({
  templateUrl: './create-currency-slide-over.component.html',
  imports: [DokaButton, DokaModal, DokaTextField, I18NextEagerPipe, ReactiveFormsModule],
})
export class CreateCurrencySlideOverComponent {
  private readonly currenciesClient = inject(CurrenciesClient);
  private readonly modalCtrl = inject(DokaModalController);
  private readonly fb = inject(NonNullableFormBuilder);
  private readonly toastService = inject(ToastService);
  private readonly i18n = inject(I18NextService);

  protected readonly isLoading = signal(false);
  protected readonly form = this.fb.group({
    isoCurrencyCode: this.fb.control('', [
      Validators.required,
      Validators.minLength(3),
      Validators.maxLength(3),
      Validators.pattern(/^[A-Za-z]{3}$/),
    ]),
  });

  protected closeModal() {
    this.modalCtrl.dismiss();
  }

  protected async submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.isLoading.set(true);
    try {
      const isoCurrencyCode = this.form.controls.isoCurrencyCode.value.toUpperCase();
      await firstValueFrom(this.currenciesClient.createCurrency(new CreateCurrencyModel({ isoCurrencyCode })));
      this.modalCtrl.dismiss(true, 'created');
    } catch {
      await this.toastService.showError(this.i18n.t('MasterData.Currencies.CreateError'));
    } finally {
      this.isLoading.set(false);
    }
  }
}
